export default __webpack_public_path__ + "static/media/orthopantomogram.cc8777fa.svg";